import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/feature/ProtectedRoute';
import AdminRoute from '../components/feature/AdminRoute';

// Public pages
const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ContactAboutPage = lazy(() => import('../pages/contact/about/page'));
const ContactFAQPage = lazy(() => import('../pages/contact/faq/page'));
const EducationPage = lazy(() => import('../pages/education/page'));
const EducationFoundationPage = lazy(() => import('../pages/education/foundation/page'));
const EducationMethodPage = lazy(() => import('../pages/education/method/page'));
const EnforceReflectPage = lazy(() => import('../pages/education/enforce-reflect/page'));
const DailyChallengePage = lazy(() => import('../pages/education/daily-challenge/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const PartnersListPage = lazy(() => import('../pages/partners/list/page'));
const PartnersGuidePage = lazy(() => import('../pages/partners/guide/page'));
const SoftwarePage = lazy(() => import('../pages/software/page'));
const SoftwareGuidePage = lazy(() => import('../pages/software/guide/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));

// Auth pages
const LoginPage = lazy(() => import('../pages/auth/login'));
const RegisterPage = lazy(() => import('../pages/auth/register'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password'));
const AuthCallbackPage = lazy(() => import('../pages/auth/callback'));

// Protected pages (require login)
const ProfilePage = lazy(() => import('../pages/profile/page'));
const PlansPage = lazy(() => import('../pages/plans/page'));
const PlansCreatePage = lazy(() => import('../pages/plans/create/page'));
const PlansTipsPage = lazy(() => import('../pages/plans/tips/page'));
const SignalsPage = lazy(() => import('../pages/signals/page'));
const SignalsJournalPage = lazy(() => import('../pages/signals/journal/page'));
const SignalsReviewPage = lazy(() => import('../pages/signals/review/page'));

// Admin
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  // ─── Public routes ────────────────────────────────────────
  { path: '/', element: <HomePage /> },

  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },

  { path: '/contact', element: <ContactPage /> },
  { path: '/contact/about', element: <ContactAboutPage /> },
  { path: '/contact/faq', element: <ContactFAQPage /> },

  { path: '/education/method', element: <EducationMethodPage /> },
  { path: '/education/enforce-reflect', element: <EnforceReflectPage /> },
  { path: '/education/daily-challenge', element: <DailyChallengePage /> },

  { path: '/partners', element: <PartnersPage /> },
  { path: '/partners/list', element: <PartnersListPage /> },
  { path: '/partners/guide', element: <PartnersGuidePage /> },

  { path: '/software', element: <SoftwarePage /> },
  { path: '/software/guide', element: <SoftwareGuidePage /> },

  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },

  // ─── Admin routes (require admin email) ────────────────────
  {
    element: <AdminRoute />,
    children: [
      { path: '/admin', element: <AdminPage /> },
      { path: '/education', element: <EducationPage /> },
      { path: '/education/foundation', element: <EducationFoundationPage /> },
    ],
  },

  // ─── Protected routes (require login) ─────────────────────
  {
    element: <ProtectedRoute />,
    children: [
      { path: '/profile', element: <ProfilePage /> },

      { path: '/plans', element: <PlansPage /> },
      { path: '/plans/create', element: <PlansCreatePage /> },
      { path: '/plans/tips', element: <PlansTipsPage /> },

      { path: '/signals', element: <SignalsPage /> },
      { path: '/signals/journal', element: <SignalsJournalPage /> },
      { path: '/signals/review', element: <SignalsReviewPage /> },
    ],
  },

  // ─── 404 ──────────────────────────────────────────────────
  { path: '*', element: <NotFoundPage /> },
];

export default routes;